import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Bienvenida");
      nav("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Error de acceso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[color:var(--bg-primary)] px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="font-heading text-3xl block mb-10">Dentainhoa<span className="text-[color:var(--accent)]">.</span></Link>
        <div className="text-xs uppercase tracking-[0.28em] text-[color:var(--text-secondary)] mb-4">Panel · Acceso</div>
        <h1 className="font-heading text-5xl tracking-tighter mb-10">Entrar al <em className="italic text-[color:var(--accent)]">estudio</em>.</h1>
        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <Label className="text-[11px] uppercase tracking-[0.2em] mb-2 block">Email</Label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required data-testid="admin-email" className="bg-white/60 border-[color:var(--border-subtle)] h-11 rounded-xl" />
          </div>
          <div>
            <Label className="text-[11px] uppercase tracking-[0.2em] mb-2 block">Contraseña</Label>
            <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required data-testid="admin-password" className="bg-white/60 border-[color:var(--border-subtle)] h-11 rounded-xl" />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full rounded-full bg-[color:var(--text-primary)] text-[color:var(--bg-primary)] py-3.5 text-sm hover:bg-[color:var(--signature-dark)] transition-colors disabled:opacity-60"
          >
            {loading ? "Entrando…" : "Entrar →"}
          </button>
        </form>
      </div>
    </div>
  );
}
